/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CarveOutSubmissionMethod = {
    Concurrent: 'concurrent',
    Manual: 'manual',
} as const;
export type CarveOutSubmissionMethod = typeof CarveOutSubmissionMethod[keyof typeof CarveOutSubmissionMethod];


export function instanceOfCarveOutSubmissionMethod(value: any): boolean {
    for (const key in CarveOutSubmissionMethod) {
        if (Object.prototype.hasOwnProperty.call(CarveOutSubmissionMethod, key)) {
            if (CarveOutSubmissionMethod[key as keyof typeof CarveOutSubmissionMethod] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CarveOutSubmissionMethodFromJSON(json: any): CarveOutSubmissionMethod {
    return CarveOutSubmissionMethodFromJSONTyped(json, false);
}

export function CarveOutSubmissionMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutSubmissionMethod {
    return json as CarveOutSubmissionMethod;
}

export function CarveOutSubmissionMethodToJSON(value?: CarveOutSubmissionMethod | null): any {
    return value as any;
}

export function CarveOutSubmissionMethodToJSONTyped(value: any, ignoreDiscriminator: boolean): CarveOutSubmissionMethod {
    return value as CarveOutSubmissionMethod;
}

